define('models/targetSegmentsProvider',["T1", "Backbone", "T1Model"], function (T1, Backbone, T1Model) {
  T1.Models.TargetSegmentsProvider = T1Model.extend({
    url: "targeting_segments/",
    fixture: "-targeting_segments"
  });
  return T1.Models.TargetSegmentsProvider;
});
